export default __webpack_public_path__ + "static/media/mf-m-min-logo.1018b851.svg";